import { createAction, props } from '@ngrx/store';

import { PagedResponse } from '../general/models/general';
import { createFailure, createSuccess } from '../utils/action-utils';
import { IInvitation } from './models/invitations';
import { ETeamPermission, ITeamMember } from './models/team';

// Get All Team Members Actions //
const getAllTeamMembersKey = '[Team] Get All Team Members';
export const getAllTeamMembers = createAction(
  getAllTeamMembersKey,
  props<{ searchTerm?: string; pageNumber?: number }>(),
);
export const getAllTeamMembersSuccess = createAction(
  createSuccess(getAllTeamMembersKey),
  props<{ pagedTeamMembers: PagedResponse<ITeamMember> }>(),
);
export const getAllTeamMembersFailure = createAction(
  createFailure(getAllTeamMembersKey),
  props<{ error: any }>(),
);

// Remove Team Member Actions //
const removeTeamMemberKey = '[Team] Remove A Team Member';
export const removeTeamMember = createAction(
  removeTeamMemberKey,
  props<{ userId: string }>(),
);
export const removeTeamMemberSuccess = createAction(
  createSuccess(removeTeamMemberKey),
);
export const removeTeamMemberFailure = createAction(
  createFailure(removeTeamMemberKey),
  props<{ error: any }>(),
);

// Edit Team Member Role Actions //
const editTeamMemberRoleKey = '[Team] Edit Team Member Role';
export const editTeamMemberRole = createAction(
  editTeamMemberRoleKey,
  props<{ userId: string; newRole: ETeamPermission }>(),
);
export const editTeamMemberRoleSuccess = createAction(
  createSuccess(editTeamMemberRoleKey),
);
export const editTeamMemberRoleFailure = createAction(
  createFailure(editTeamMemberRoleKey),
  props<{ error: any }>(),
);

// Invite Team Member Actions //
const inviteTeamMemberKey = '[Team] Invite A Team Member';
export const inviteTeamMember = createAction(
  inviteTeamMemberKey,
  props<{ email: string; role: ETeamPermission }>(),
);
export const inviteTeamMemberSuccess = createAction(
  createSuccess(inviteTeamMemberKey),
);
export const inviteTeamMemberFailure = createAction(
  createFailure(inviteTeamMemberKey),
  props<{ error: any }>(),
);

// Get Invitations Actions //
const getInvitationsKey = '[Team] Get Invitations';
export const getInvitations = createAction(
  getInvitationsKey,
  props<{ searchTerm?: string; pageNumber?: number }>(),
);
export const getInvitationsSuccess = createAction(
  createSuccess(getInvitationsKey),
  props<{ pagedInvitations: PagedResponse<IInvitation> }>(),
);
export const getInvitationsFailure = createAction(
  createFailure(getInvitationsKey),
  props<{ error: any }>(),
);

// Resend Invitation Actions //
const resendInvitationKey = '[Team] Resend Invitation';
export const resendInvitation = createAction(
  resendInvitationKey,
  props<{ invitationId: string }>(),
);
export const resendInvitationSuccess = createAction(
  createSuccess(resendInvitationKey),
);
export const resendInvitationFailure = createAction(
  createFailure(resendInvitationKey),
  props<{ error: any }>(),
);

// Delete Invitation Actions //
const deleteInvitationKey = '[Team] Delete Invitation';
export const deleteInvitation = createAction(
  deleteInvitationKey,
  props<{ invitationId: string }>(),
);
export const deleteInvitationSuccess = createAction(
  createSuccess(deleteInvitationKey),
);
export const deleteInvitationFailure = createAction(
  createFailure(deleteInvitationKey),
  props<{ error: any }>(),
);
